import { render } from "./MockPaperHistory.vue?vue&type=template&id=04117c50&scoped=true&ts=true"
import script from "./MockPaperHistory.vue?vue&type=script&lang=ts"
export * from "./MockPaperHistory.vue?vue&type=script&lang=ts"

import "./MockPaperHistory.vue?vue&type=style&index=0&id=04117c50&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04117c50"]])

export default __exports__